import type { AdSlotFragment } from '@haaretz/s-fragments/AdSlot';
import type { ListFragment } from '@haaretz/s-fragments/List';
import type { TaboolaFragment } from '@haaretz/s-fragments/Taboola';

const listTypename: ListFragment['__typename'] = 'htz_list_List';
const adSlotTypename: AdSlotFragment['__typename'] = 'AdSlot';
const taboolaTypename: TaboolaFragment['__typename'] = 'Taboola';

export default function isSideBoxItemElement(
  item:
    | {
        __typename?: string;
      }
    | undefined
    | null
): item is AdSlotFragment | ListFragment | TaboolaFragment {
  if (!(item instanceof Object)) return false;

  return (
    item.__typename === listTypename ||
    item.__typename === adSlotTypename ||
    item.__typename === taboolaTypename
  );
}
